var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataLoaded)?_c('main',{staticClass:"container homepage",attrs:{"role":"main"}},[_c('h1',{attrs:{"id":"content"}},[_vm._v("About Me")]),_c('span',{domProps:{"innerHTML":_vm._s(this.homeDescription)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }